import useTopicWork from "common/topic/provider/TopicWork/TopicWork";
import { useTopicWorkSetPath } from "common/topic/provider/TopicWork/UseTopicWorkSetPath";
import { isInputWayTextTopic } from "common/topic/topic_tag_common";
import TopicInputWayTextPlay from "components/common/answer/input_way_text/TopicInputWayTextPlay";
import React from "react";

const InputWayTextPlay = () => {
  const { topicWork } = useTopicWork();
  useTopicWorkSetPath();
  const isInputWayText = React.useMemo(
    () => topicWork && isInputWayTextTopic(topicWork),
    [topicWork]
  );

  return (
    <>
      {topicWork?.id && isInputWayText && (
        <TopicInputWayTextPlay topic={topicWork} />
      )}
    </>
  );
};

export default InputWayTextPlay;
